export enum TruckCabinType {
  Unknown = 0,
  DayCab = 1,
  Sleeper = 2
}

export const TruckCabinTypeMapping: Record<TruckCabinType, string> = {
  [TruckCabinType.Unknown]: 'Unknown',
  [TruckCabinType.DayCab]: 'Day Cab',
  [TruckCabinType.Sleeper]: 'Sleeper'
};
